import React from 'react';
import HeroBookDemoCta from './HeroBookDemoCta';
import HeroBrandLogo from './HeroBrandLogo';
import HeroTypewriterTitle from './HeroTypewriterTitle';
import './HeroSection.css';

const HeroSection: React.FC = () => (
  <section className="hero">
    <div className="hero-bg" aria-hidden="true">
      <img src="/images/hero_lummo.png" alt="" loading="eager" className="hero-bg-img" />
      <div className="hero-vignette" />
    </div>

    <div className="hero-container">
      <div className="hero-inner">
        <HeroTypewriterTitle text="AI-Native Infrastructure for Clinical Trials" />
        <p className="hero-subtitle">
          Transform clinical research with intelligent automation. From protocol design to patient
          recruitment, our AI platform accelerates trials while ensuring regulatory compliance across
          LATAM markets.
        </p>
        <HeroBookDemoCta />
        <HeroBrandLogo />
      </div>
    </div>

    <div className="scroll-indicator" aria-hidden="true">
      <span className="scroll-dot" />
    </div>
  </section>
);

export default HeroSection;
